import React from 'react'

// Base
import ColorsSG from './sg-includes/ColorsSG'
import FontsSG from './sg-includes/FontsSG'
import TypeSG from './sg-includes/TypeSG'
// Basic
import LayoutSG from './sg-includes/LayoutSG'
import ButtonSG from './sg-includes/ButtonSG'
// Form
import RadioSG from './sg-includes/RadioSG'
import CheckboxSG from './sg-includes/CheckboxSG'
import InputSG from './sg-includes/InputSG'
import SelectSG from './sg-includes/SelectSG'
import SwitchSG from './sg-includes/SwitchSG'
import SliderSG from './sg-includes/SliderSG'
import DatePickerSG from './sg-includes/DatePickerSG'
// Data
import TableSG from './sg-includes/TableSG'
import TagSG from './sg-includes/TagSG'
import PaginationSG from './sg-includes/PaginationSG'
import BadgeSG from './sg-includes/BadgeSG'
// Notice
import AlertSG from './sg-includes/AlertSG'
import LoadingSG from './sg-includes/LoadingSG'
import MessageSG from './sg-includes/MessageSG'
import MessageBoxSG from './sg-includes/MessageBoxSG'
import NotificationSG from './sg-includes/NotificationSG'
// Nav
import MenuSG from './sg-includes/MenuSG'
import TabsSG from './sg-includes/TabsSG'
import BreadcrumbsSG from './sg-includes/BreadcrumbsSG'
import DropDownSG from './sg-includes/DropDownSG'
// Other
import DialogSG from './sg-includes/DialogSG'
import TooltipSG from './sg-includes/TooltipSG'
import PopoverSG from './sg-includes/PopoverSG'
import CarouselSG from './sg-includes/CarouselSG'
import UploadSG from './sg-includes/UploadSG'
import CollapseSG from './sg-includes/CollapseSG'

const StyleGuide = () => (
    <div className="container sg-styleguide">
        <div className="row">
            <div className="columns small-12">
                <h1>This is the Style Guide</h1>

                <div className="sg-section--group">
                    <h3>
                        <span>Colors</span>
                    </h3>
                    <ColorsSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Fonts</span>
                    </h3>
                    <FontsSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Type</span>
                    </h3>
                    <TypeSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Button</span>
                    </h3>
                    <ButtonSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Layout (Foundation)</span>
                    </h3>
                    <LayoutSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Radio</span>
                    </h3>
                    <RadioSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Checkbox</span>
                    </h3>
                    <CheckboxSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Input</span>
                    </h3>
                    <InputSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Select</span>
                    </h3>
                    <SelectSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Switch</span>
                    </h3>
                    <SwitchSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Slider</span>
                    </h3>
                    <SliderSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Date Picker</span>
                    </h3>
                    <DatePickerSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Table</span>
                    </h3>
                    <TableSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Tag</span>
                    </h3>
                    <TagSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Pagination</span>
                    </h3>
                    <PaginationSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Badge</span>
                    </h3>
                    <BadgeSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Alert</span>
                    </h3>
                    <AlertSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Loading</span>
                    </h3>
                    <LoadingSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Message</span>
                    </h3>
                    <MessageSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Message Box</span>
                    </h3>
                    <MessageBoxSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Notification</span>
                    </h3>
                    <NotificationSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Menu</span>
                    </h3>
                    <MenuSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Tabs</span>
                    </h3>
                    <TabsSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Breadcrumbs</span>
                    </h3>
                    <BreadcrumbsSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>DropDown</span>
                    </h3>
                    <DropDownSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Dialog</span>
                    </h3>
                    <DialogSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Tooltip</span>
                    </h3>
                    <TooltipSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Popover</span>
                    </h3>
                    <PopoverSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Carousel</span>
                    </h3>
                    <CarouselSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Upload</span>
                    </h3>
                    <UploadSG />
                </div>

                <div className="sg-section--group">
                    <h3>
                        <span>Collapse</span>
                    </h3>
                    <CollapseSG />
                </div>
            </div>
        </div>
    </div>
)

export default StyleGuide
